// src/config/oauth.js
const oauthConfig = {
    domain: 'id-dev.minimarket116.kz',
    //clientId: '4826585b-c881-4600-b7cc-c2a63c339ca9',
    clientId: 'db342b4c-545a-4c4f-851d-bbe2b2373a17',
    redirectUri: 'https://pos.minimarket116.kz/callback',
    //redirectUri: 'http://localhost:3000/callback',
    responseType: 'code',
    scope: 'all',
    codeChallengeMethod: 'S256'
};

export default oauthConfig;